// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"631053d2","2574":"53a477ed","3818":"46761c4b","6098":"997e2414","6215":"997e2414","6570":"997e2414"}[chunkId] + ".chunk.css";
};